import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

import { toastrError } from '@portals/redux/actions/toastr';
import { PartnerFeatureFlagsType } from '@portals/types';

import { fetchApiRequest, useRequestOptions } from '../../utils';
import {
  configurationQueryKeys,
  FEATURE_FLAGS_API_URL,
} from './configuration.constants';
import { ConfigType } from './configuration.types';

export const useUpdateFeatureFlags = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const { url, options } = useRequestOptions({
    url: FEATURE_FLAGS_API_URL,
    method: 'POST',
  });

  return useMutation({
    mutationFn: (featureFlags: { feature_flags: PartnerFeatureFlagsType }) =>
      fetchApiRequest(url, {
        ...options,
        body: JSON.stringify(featureFlags),
      }),
    onSuccess: (response: ConfigType) => {
      queryClient.setQueriesData(configurationQueryKeys.config, response);
    },
    onError: ({ error }: any) => {
      dispatch(toastrError(error));
    },
  });
};
